import { Button } from 'src/components/atoms';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
  min-height: 100vh;
  height: 100%;
`;

export const BodyContainer = styled.div`
  padding: 20px;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
`;

export const ButtonWithIcon = styled(Button)`
  display: flex;
  column-gap: 8px;
`;

export const GroupsBody = styled.div`
  margin-top: 20px;
`;

export const GroupsContainer = styled.ul<{ rows: number }>`
  display: grid;
  grid-template-columns: 3fr 1fr;
  padding: 0;
  margin: 0;
  column-gap: 20px;
  row-gap: 20px;
  list-style-type: none;
  grid-template-areas: ${(props) =>
    new Array(props.rows)
      .fill(0)
      .map((_, i) => `'group-${i} summary' \n`)
      .join('')};
`;

export const GroupListItem = styled.li<{ row: number }>`
  display: flex;
  justify-content: start;
  width: 100%;
  padding: 0;
  margin: 0;
  column-gap: 20px;
  grid-area: ${(props) => `group-${props.row}`};
`;

export const Summary = styled.li`
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  border-radius: 12px;
  padding: 20px;
  border: solid 1px
    ${(props) => props.theme.atlas.semantic.color.ui.divider.default};
  height: fit-content;
  grid-area: summary;
  box-shadow: 0px 0px 1px 0px #00000066;
  box-shadow: 0px 8px 24px -6px #00000029;
`;

export const SummaryTitle = styled.h3`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  margin: 0;
  margin-bottom: 10px;
`;

export const SummaryStatRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SummaryStat = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  margin: 0;
  margin-bottom: 5px;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  row-gap: 28px;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 80px);
  justify-content: center;
`;

export const EmptyStateTitle = styled.h2`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH3)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
`;

export const EmptyStateBody = styled.div`
  display: flex;
  row-gap: 16px;
  flex-direction: column;
  align-items: center;
`;

export const EmptyStateDescription = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin: 0;
  max-width: 380px;
  text-align: center;
`;
